import React, {useEffect, useState} from 'react';
import './Pool.css';
import {withTranslation} from 'react-i18next';
import useWindowDimensions from "../../utils/WindowDimensions";
import {Avatar, Button, Grid, IconButton, ListItem, makeStyles, Snackbar, Tab, Typography} from '@material-ui/core';
import {TabContext, TabList, TabPanel} from '@material-ui/lab';
import {useDispatch, useSelector} from "react-redux";
import {poolActions} from "../../redux/actions/poolActions";
import {onClickConnect, onClickInstall, unlockNew, unlockAllLp,} from '../../utils/Sign'
import {isValidAddress} from "ethereumjs-util";
import AddLiquidity from "./components/addLiquidity";
import {roundingDown} from "../../utils/RoundingDown";
import {convertTimeString, getIcons, isValidBtcAddress, isValidDogeAddress} from "../../utils/Common";
import HarvestLiquidity from "./components/harvestLiquidity";
import LiquidityHistoryDetail from "./components/liquidityHistoryDetail";
import RemoveLiquidity from "./components/removeLiquidity";
import Lock from "./components/lock";
import Unlock from "./components/unlock";
import UnlockAll from "./components/unlockAll";
import CloseIcon from "@material-ui/icons/Close";
import {Helmet} from "react-helmet";
import {walletActions} from "../../redux/actions/walletActions";
import i18n from '../../i18n';
import { useWalletStore } from '../../store/useStore'

const rewardIcon = 'https://cdn.swapallapp.com/l2/images/rewardIcon.png'

const Web3 = require("web3");

function Pool({
    t, navBarHeight,openWalletModal
}) {

    const { height, width } = useWindowDimensions();
    const useStyles = makeStyles((theme) => ({
        root: {
            ...theme.typography.button,
            backgroundColor: '#010846',
            padding: theme.spacing(1),
            flexGrow: 1,
            height: height - navBarHeight,
            textAlign: 'center'
        },

        btn: {
            backgroundColor: '#83ACF4',
            color: '#010846',
            borderColor: 'transparent',
            borderRadius: 25,
            height: 45,
            fontWeight: 600,
            minWidth: 100
        },
        btn_disabled: {
            backgroundColor: '#83ACF4',
            color: '#010846',
            borderColor: 'transparent',
            borderRadius: 25,
            height: 45,
            fontWeight: 600,
            opacity: 0.2
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        },
        list: {
            width: 400,
            height: 400,
            backgroundColor: theme.palette.background.paper,
            overflow: 'auto',
        },
        tab: {
            root: {
                '&$focused': {
                    color: '#000',
                },
            },
            focused: {},
        }
    }));
    const classes = useStyles();
    const { address, setAddress, chainId, setChainId, network, setNetwork, pubKey, setPublicKey,
        walletDisconnected, setWalletDisconnected, dappConnected, setDappConnected, autoSign, setAutoSign,
        currentWallet, setWallet, startWatch, setStartWatch, button1, button2, setButton1, setButton2, setButton1Disabled, setButton2Disabled,
        button1Disabled, button2Disabled
    } = useWalletStore()
    const [tabValue, setTabValue] = useState('liquidityPool');
    const [addLiquidityVisible, setAddLiquidityVisible] = useState(false);
    const [addLiquidityValue, setAddLiquidityValue] = useState({});
    const [removeLiquidityVisible, setRemoveLiquidityVisible] = useState(false);
    const [removeLiquidityValue, setRemoveLiquidityValue] = useState({});
    const [harvestLiquidityVisible, setHarvestLiquidityVisible] = useState(false);
    const [harvestLiquidityValue, setHarvestLiquidityValue] = useState({});
    const [liquidityHistoryVisible, setLiquidityHistoryVisible] = useState(false);
    const [liquidityHistoryValue, setLiquidityHistoryValue] = useState({});
    const [lockVisible, setLockVisible] = useState(false);
    const [lockValue, setLockValue] = useState({});
    const [unlockVisible, setUnlockVisible] = useState(false);
    const [unlockValue, setUnlockValue] = useState({});
    const [unlockAllVisible, setUnlockAllVisible] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState("");
    const [snackBarVisible, setSnackBarVisible] = React.useState(false);

    const { registered, loggedIn, loggingIn, loading } = useSelector(state => state.auth)
    const {
        poolsApy,
        myLocker,
        liquidityPools,
        myLiquidityPools,
        myLiquidityTransactions,
        addLiquidityLoading,
        removeLiquidityLoading,
        harvestLoading,
        lockLpLoading,
        addFailed,
        addSucceed,
        removeFailed,
        removeSucceed,
        harvestFailed,
        harvestSucceed,
        lockLpSucceed,
        lockLpFailed,
        lockLpMessage,
        addMessage,
        removeMessage,
        harvestMessage,
        currentTime,
        unlockLpLoading,
        unlockLpSucceed,
        unlockLpFailed,
        unlockLpMessage,
        poolSigning,
        unlockAllLpLoading,
        unlockAllLpSucceed,
        unlockAllLpFailed,
        unlockAllLpMessage,
        unlockables
    } = useSelector(state => state.pool)
    const { token } = useSelector(state => state.auth)
    const { tokenIcons } = useSelector(state => state.wallet)

    const dispatch = useDispatch();

    useEffect(() => {
        if (loggedIn) {
            dispatch(poolActions.getAllLiquidityPool(token))
            dispatch(walletActions.getAllTokenStatus(token))
        }
        return () => {
        }
    }, [loggedIn])

    useEffect(() => {
        if (addLiquidityLoading === false || removeLiquidityLoading === false || harvestLoading === false || lockLpLoading === false || unlockLpLoading === false || unlockAllLpLoading === false) {
            if (addFailed) {
                setSnackBarMessage(t(addMessage))
                setSnackBarVisible(true)
                dispatch(poolActions.clearAddState())
            } else if (addSucceed) {
                setSnackBarMessage(t("pool-addLiquidity-succeed"))
                setSnackBarVisible(true)
                dispatch(poolActions.clearAddState())
            }
            if (removeFailed) {
                setSnackBarMessage(t(removeMessage))
                setSnackBarVisible(true)
                dispatch(poolActions.clearRemoveState())
            } else if (removeSucceed) {
                setSnackBarMessage(t("pool-removeLiquidity-succeed"))
                setSnackBarVisible(true)
                dispatch(poolActions.clearRemoveState())
            }
            if (harvestFailed) {
                setSnackBarMessage(t(harvestMessage))
                setSnackBarVisible(true)
                dispatch(poolActions.clearHarvestState())
            } else if (harvestSucceed) {
                setSnackBarMessage(t("pool-collectReward-succeed"))
                setSnackBarVisible(true)
                dispatch(poolActions.clearHarvestState())
            }
            if (lockLpFailed) {
                setSnackBarMessage(t(lockLpMessage))
                setSnackBarVisible(true)
                dispatch(poolActions.clearLockLpState())
            } else if (lockLpSucceed) {
                setSnackBarMessage(t("pool-lock-succeed"))
                setSnackBarVisible(true)
                dispatch(poolActions.clearLockLpState())
            }
            if (unlockLpFailed) {
                setSnackBarMessage(t(unlockLpMessage))
                setSnackBarVisible(true)
                dispatch(poolActions.clearUnlockLpState())
            } else if (unlockLpSucceed) {
                setSnackBarMessage(t("pool-unlock-succeed"))
                setSnackBarVisible(true)
                dispatch(poolActions.clearUnlockLpState())
            }
            if (unlockAllLpFailed) {
                setSnackBarMessage(t(unlockAllLpMessage))
                setSnackBarVisible(true)
                dispatch(poolActions.clearUnlockAllLpState())
            } else if (unlockAllLpSucceed) {
                setSnackBarMessage(t("pool-unlockAll-succeed"))
                setSnackBarVisible(true)
                dispatch(poolActions.clearUnlockAllLpState())
            }
        }
        return () => {
        }
    }, [addLiquidityLoading, removeLiquidityLoading, harvestLoading, lockLpLoading, unlockLpLoading, unlockAllLpLoading])

    useEffect(() => {
        if (tabValue === "liquidityPool" && !(addLiquidityLoading)) {
            dispatch(poolActions.getAllLiquidityPool())
        } else if (loggedIn && tabValue === "myLiquidityPool" && !(addLiquidityLoading || removeLiquidityLoading || harvestLoading || lockLpLoading)) {
            dispatch(poolActions.getMyPoolApy(token))
            dispatch(poolActions.getMyLiquidityPool(token))
        } else if (loggedIn && tabValue === "myLocker" && !(unlockLpLoading || unlockAllLpLoading)) {
            dispatch(poolActions.getCurrentTime(token))
            dispatch(poolActions.getUnlockable(token))
            dispatch(poolActions.getMyLocker(token))
        } else if (loggedIn && tabValue === "liquidityPoolHistory") {
            dispatch(poolActions.getMyLiquidityTransactions(token))
        }
        return () => {
        }
    }, [loggedIn, tabValue, addLiquidityLoading, removeLiquidityLoading, harvestLoading, lockLpLoading, unlockLpLoading, unlockAllLpLoading])


    useEffect(() => {
        console.log('liquidityPools: ', liquidityPools, getIcons('btc', tokenIcons, true))
        console.log('tokenIcons: ', tokenIcons)
    }, [liquidityPools, tokenIcons])


    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarVisible(false);
    };

    const renderLiquidityPoolCard = (pool) => {

        return (
            <div key={pool.id} style={{ backgroundColor: 'white', flexDirection: 'column', marginBottom: 40, display: 'flex', borderRadius: 16, width: '100%', overflow: 'hidden' }}>
                {/*<div style={{ position: 'absolute', alignSelf: 'flex-end', display: 'flex', marginTop: 16, marginRight: 24, alignItems: 'center' }}>*/}
                {/*<div style={{ height: 6, width: 6, borderRadius: 3, backgroundColor: pool.isEnd ? '#FC4141' : "#251CFF", marginRight: 4 }} />*/}
                {/*<Typography color="textSecondary" style={{ fontSize: 12, fontWeight: 'bold', color: pool.isEnd ? '#FC4141' : "#251CFF" }}>*/}
                {/*    {pool.isEnd ? t("pool-closed") : t("pool-opening")}*/}
                {/*</Typography>*/}
                {/*</div>*/}

                <div style={{ marginTop: 24, marginBottom: 24, marginLeft: 24, marginRight: 24, display: 'flex', flexDirection: 'column' }}>
                    <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                        <div style={{ flexDirection: 'row', display: 'flex', backgroundColor: 'white', height: 48, alignItems: 'center', width: 100, justifyContent: 'space-between', borderRadius: 24 }}>

                            <Avatar alt={'Coin Icon'} src={getIcons(pool.token1, tokenIcons, true)} style={{ height: 32, width: 32, marginLeft: 12 }} />

                            <Avatar alt={'Coin Icon'} src={getIcons(pool.token2, tokenIcons, true)} style={{ height: 32, width: 32, marginRight: 12 }} />


                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 16 }}>
                            <Typography style={{ fontSize: 18, color: '#363636', fontWeight: 'bold' }} >
                                {pool.token1}-{pool.token2}
                            </Typography>


                            <Typography style={{ fontSize: 12, color: '#8786A7', marginTop: -4, fontWeight: 'bold' }}>
                                {t('price')}: 1{pool.token1} ≈ {pool.amount2 === 0 ? "-" : roundingDown(pool.amount2 / pool.amount1, 4)} {pool.token2}
                            </Typography>
                        </div>
                    </div>

                    <div style={{ height: 1, width: '100%', backgroundColor: 'white', opacity: 0.2, marginTop: 16, marginBottom: 16 }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                        <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                            {t('pool-totalLiquidity')}
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Avatar alt="Coin Icon" src={getIcons(pool.token1, tokenIcons, true)} style={{ height: 20, width: 20, }} />
                            <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold', marginRight: 8 }} >
                                {roundingDown(pool.amount1, 2)} {pool.token1}
                            </Typography>

                            <Avatar alt="Coin Icon" src={getIcons(pool.token2, tokenIcons, true)} style={{ height: 20, width: 20, }} />
                            <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                {roundingDown(pool.amount2, 2)} {pool.token2}
                            </Typography>
                        </div>
                    </div>



                    {
                        pool.tokenReward2 ?
                            [
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                        {t('pool-dailyReward')}
                                    </Typography>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>

                                        <Avatar alt="Coin Icon" src={getIcons(pool.tokenReward, tokenIcons, true)} style={{ height: 20, width: 20, }} />

                                        <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold', marginRight: 8 }} >
                                            {roundingDown(pool.reward, 4)} {pool.tokenReward},
                                        </Typography>

                                        <Avatar alt="Coin Icon" src={getIcons(pool.tokenReward2, tokenIcons, true)} style={{ height: 20, width: 20, }} />
                                        <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                            {roundingDown(pool.reward2, 4)} {pool.tokenReward2}
                                        </Typography>
                                    </div>
                                </div>,
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                        {t('pool-tokenApy')}
                                    </Typography>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>

                                        <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold', marginRight: 8 }} >
                                            {pool.apyDetails.length > 1 && pool.apyDetails[0].apy > 0 ? pool.apyDetails[0].tokenReward + " " + roundingDown(pool.apyDetails[0].apy * 100, 2) + "%" : pool.tokenReward + "--%"}
                                        </Typography>
                                        <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold', marginRight: 8 }} >
                                            {pool.apyDetails.length > 1 && pool.apyDetails[1].apy > 0 ? pool.apyDetails[1].tokenReward + " " + roundingDown(pool.apyDetails[1].apy * 100, 2) + "%" : pool.tokenReward2 + "--%"}
                                        </Typography>
                                    </div>
                                </div>
                            ]

                            : <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-dailyReward')}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                    <Avatar alt="Coin Icon" src={getIcons(pool.tokenReward, tokenIcons, true)} style={{ height: 20, width: 20, }} />

                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {roundingDown(pool.reward, 4)} {pool.tokenReward}
                                    </Typography>
                                </div>
                            </div>
                    }

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
                        <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                            {t('pool-apy')}
                        </Typography>
                        {
                            pool.isBoostEnabled ?
                                <Typography style={{ fontSize: 14, color: '#251CFF', fontWeight: 'bold' }} >
                                    {pool.apy ? pool.apy != 0 ? roundingDown(pool.apy * 100, 2) : '--' : '--'}% ~ {pool.maxApy ? pool.maxApy != 0 ? roundingDown(pool.maxApy * 100, 2) : '--' : '--'}% (+{roundingDown(pool.tradingFeeApy * 100, 2)}%)
                                </Typography>
                                : <Typography style={{ fontSize: 14, color: '#251CFF', fontWeight: 'bold' }} >
                                    {pool.apy ? pool.apy != 0 ? roundingDown(pool.apy * 100, 2) : '--' : '--'}% (+{roundingDown(pool.tradingFeeApy * 100, 2)}%)
                                </Typography>
                        }
                    </div>



                </div>
                <div className={classes.wrapper}>
                    {
                        !isValidBtcAddress(address) && !isValidDogeAddress(address) ?
                            <Button style={{ height: 52, width: '100%', backgroundColor: '#4477F1', borderRadius: 0 }} onClick={openWalletModal}>

                                <Typography style={{ fontSize: 16, fontWeight: 'bold', color: '#010846' }}>
                                    {button1}
                                </Typography>
                            </Button>
                            :
                            null
                    }
                    {
                        (isValidBtcAddress(address) || isValidDogeAddress(address)) && !loggedIn ?
                            <Button style={{ height: 52, width: '100%', backgroundColor: '#75E2F9', borderRadius: 0 }} className={button2Disabled ? classes.btn_disabled : classes.btn} onClick={(!registered || !loggedIn) && !loading ? () => unlockNew(
                                address,
                                chainId,
                                network,
                                registered,            
                                currentWallet,
                                dispatch,
                                setAddress, setChainId, setNetwork, setWallet, setDappConnected, setPublicKey, setStartWatch, setAutoSign, setWalletDisconnected
                            ) : null} variant="outlined" color="primary" disabled={button2Disabled}>


                                <Typography style={{ fontSize: 16, fontWeight: 'bold', color: '#010846' }}>
                                    {button2}
                                </Typography>
                            </Button>
                            :
                            null
                    }
                    {
                        (isValidBtcAddress(address) || isValidDogeAddress(address)) && loggedIn ?
                            <Button
                                // variant="outlined"
                                // color="primary"
                                style={{ height: 52, width: '100%', backgroundColor: '#251CFF', borderRadius: 0 }}
                                disabled={!loggedIn}
                                onClick={() => {
                                    if (pool.amount1 === 0 && pool.amount2 === 0 && pool.reward === 0) {
                                        setSnackBarMessage(t('pool-addLiquidity-disable'))
                                        setSnackBarVisible(true)
                                    } else {
                                        setAddLiquidityVisible(true);
                                        setAddLiquidityValue({
                                            token1: pool.token1,
                                            token2: pool.token2,
                                            poolId: pool.id,
                                            tokenReward: pool.tokenReward,
                                            isBoostEnabled: pool.isBoostEnabled
                                        });
                                    }
                                }}
                            >
                                <Typography style={{ fontSize: 16, fontWeight: 'bold', color: 'white' }}>
                                    +{t('pool-addLiquidity')}
                                </Typography>
                            </Button>
                            : null
                    }
                </div>
            </div>)
    }
    const renderMyLiquidityPoolCard = (pool) => {
        let apy = poolsApy.find(item => item.poolId === pool.poolId)
        return (
            <div key={pool.poolId} style={{ backgroundColor: 'white', flexDirection: 'column', marginBottom: 40, display: 'flex', borderRadius: 16, width: '100%', overflow: 'hidden' }}>
                <div style={{ marginTop: 24, marginBottom: 24, marginLeft: 24, marginRight: 24, display: 'flex', flexDirection: 'column' }}>
                    <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                        <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                            <div style={{ flexDirection: 'row', display: 'flex', backgroundColor: '#F5F5F5', height: 48, alignItems: 'center', width: 100, justifyContent: 'space-between', borderRadius: 24 }}>
                                <Avatar src={getIcons(pool.token1, tokenIcons, true)} style={{ height: 32, width: 32, marginLeft: 12 }} />
                                <Avatar src={getIcons(pool.token2, tokenIcons, true)} style={{ height: 32, width: 32, marginRight: 12 }} />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 16 }}>
                                <Typography style={{ fontSize: 18, color: '#363636', fontWeight: 'bold' }} >
                                    {pool.token1}-{pool.token2}
                                </Typography>


                                <Typography style={{ fontSize: 12, color: '#8786A7', marginTop: -4, fontWeight: 'bold' }}>
                                    {t('pool-poolShare')}: {roundingDown(pool.shareOfPool * 100, 8)}%
                                </Typography>
                            </div>
                        </div>
                        <Button
                            style={{ width: 120, marginLeft: 16, backgroundColor: '#FF2525', borderRadius: 8, opacity: !loggedIn ? 0.5 : 1 }}
                            disabled={!loggedIn}
                            onClick={() => {
                                setRemoveLiquidityVisible(true);
                                setRemoveLiquidityValue({
                                    token1: pool.token1,
                                    token2: pool.token2,
                                });
                            }}
                        >
                            <Typography style={{textTransform:'none', fontSize: 14, fontWeight: 'bold', color: 'white', textTransform: 'uppercase' }}>
                                {t('pool-removeLiquidity')}
                            </Typography>
                        </Button>
                    </div>
                    <div style={{ height: 1, width: '100%', backgroundColor:'#363636', opacity: 0.2, marginTop: 16, marginBottom: 16 }} />

                    {pool.isBoostEnabled ?
                        [
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    LP {t('pool-myPool-lpLocked')}/{t('pool-myPool-lpTotal')}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {/* <Avatar alt="Coin Icon" src={eth} style={{ height: 20, width: 20, }} /> */}
                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {roundingDown(pool.lpTokenCapital.frozen, 4)} / {roundingDown(pool.lpTokenCapital.total, 4)}
                                    </Typography>
                                </div>
                            </div>,

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-myPool-myApy')}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {apy ? apy.boostedApy != 0 ? roundingDown(apy.boostedApy * 100, 2) : '--' : '--'}%
                                    </Typography>
                                    <Button style={{ borderWidth: 1.6, borderColor: '#1DF3AA', height: 20, backgroundColor: '#1DF3AA', borderRadius: 4, marginLeft: 12, opacity: !loggedIn ? 0.5 : 1 }}
                                        disabled={!loggedIn}
                                        onClick={() => {
                                            setLockValue({
                                                pid: pool.poolId,
                                                token1: pool.token1,
                                                token2: pool.token2,
                                            })
                                            setLockVisible(true)
                                        }}
                                    >
                                        <Typography style={{ fontSize: 12, color: '#363636', fontWeight: 'bold', textTransform: 'none' }} >
                                            {t('pool-myPool-lock')}
                                        </Typography>
                                    </Button>
                                </div>
                            </div>
                        ]
                        : [
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-lpAmount')}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {roundingDown(pool.lpTokenCapital.total, 4)}
                                    </Typography>
                                </div>
                            </div>
                        ]
                    }

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
                        <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                            {t('pool-lpValue')}
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Avatar alt="Coin Icon" src={getIcons(pool.token1, tokenIcons, true)} style={{ height: 20, width: 20, }} />
                            <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold', marginRight: 8 }} >
                                {roundingDown(pool.staked1, 4)} {pool.token1}
                            </Typography>

                            <Avatar alt="Coin Icon" src={getIcons(pool.token2, tokenIcons, true)} style={{ height: 20, width: 20, }} />
                            <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                {roundingDown(pool.staked2, 4)} {pool.token2}
                            </Typography>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
                        <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                            {t('pool-collectable')}
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {
                                pool.tokenReward2 ?
                                    [
                                        <Avatar alt="Coin Icon" src={getIcons(pool.tokenReward, tokenIcons, true)} style={{ height: 20, width: 20, }} />
                                        ,
                                        <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold', marginRight: 8 }} >
                                            {roundingDown(pool.availableRewards, 4)} {pool.tokenReward}
                                        </Typography>
                                        ,
                                        <Avatar alt="Coin Icon" src={getIcons(pool.tokenReward2, tokenIcons, true)} style={{ height: 20, width: 20, }} />
                                        ,
                                        <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                            {roundingDown(pool.availableRewards2, 4)} {pool.tokenReward2}
                                        </Typography>
                                        ,
                                        <Button style={{ borderWidth: 1.6, borderColor: '#1DF3AA', height: 20, backgroundColor: '#1DF3AA', borderRadius: 4, marginLeft: 12, opacity: !loggedIn || (pool.availableRewards <= 0 && pool.availableRewards2 <= 0) ? 0.5 : 1 }}
                                            disabled={!loggedIn || (pool.availableRewards <= 0 && pool.availableRewards2 <= 0)}
                                            onClick={() => {
                                                setHarvestLiquidityValue({
                                                    pid: pool.poolId,
                                                    token: pool.tokenReward,
                                                    token2: pool.tokenReward2
                                                })
                                                setHarvestLiquidityVisible(true)
                                            }}
                                        >
                                            <Typography style={{ fontSize: 12, color: '#363636', fontWeight: 'bold', textTransform: 'none' }} >
                                                {t('pool-collectReward')}
                                            </Typography>
                                        </Button>
                                    ]
                                    :
                                    [
                                        <Avatar alt="Coin Icon" src={getIcons(pool.tokenReward, tokenIcons, true)} style={{ height: 20, width: 20, }} />
                                        ,
                                        <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                            {roundingDown(pool.availableRewards, 4)} {pool.tokenReward}
                                        </Typography>
                                        ,
                                        <Button style={{ borderWidth: 1.6, borderColor: '#1DF3AA', height: 20, backgroundColor: '#1DF3AA', borderRadius: 4, marginLeft: 12, opacity: !loggedIn || pool.availableRewards <= 0 ? 0.5 : 1 }}
                                            disabled={!loggedIn || pool.availableRewards <= 0}
                                            onClick={() => {
                                                setHarvestLiquidityValue({
                                                    pid: pool.poolId,
                                                    token: pool.tokenReward,
                                                    token2: pool.tokenReward2
                                                })
                                                setHarvestLiquidityVisible(true)
                                            }}
                                        >
                                            <Typography style={{ fontSize: 12, color: 'white', fontWeight: 'bold', textTransform: 'none' }} >
                                                {t('pool-collectReward')}
                                            </Typography>
                                        </Button>
                                    ]
                            }

                        </div>

                    </div>

                </div>

                <div className={classes.wrapper}>
                    <Button
                        style={{ height: 52, width: '100%', backgroundColor: '#251CFF', borderRadius: 0, opacity: !loggedIn ? 0.5 : 1 }}
                        disabled={!loggedIn}
                        onClick={() => {
                            setAddLiquidityVisible(true);
                            setAddLiquidityValue({
                                token1: pool.token1,
                                token2: pool.token2,
                                poolId: pool.poolId,
                                tokenReward: pool.tokenReward,
                                isBoostEnabled: pool.isBoostEnabled
                            });
                        }}
                    >

                        <Typography style={{ fontSize: 16, fontWeight: 'bold', color: 'white' }}>
                            +{t('pool-addLiquidity')}
                        </Typography>
                    </Button>

                </div>
            </div>)
    }

    const renderMyLiquidityTransactions = (pool) => {
        return (
            <div key={pool.id} style={{ backgroundColor: 'white', flexDirection: 'column', marginBottom: 40, display: 'flex', borderRadius: 16, width: '100%', overflow: 'hidden' }}>
                {
                    pool.type === 1 ?
                        <ListItem
                            button
                            onClick={() => {
                                // setLiquidityHistoryValue(pool)
                                // setLiquidityHistoryVisible(true)
                            }}
                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                        >
                            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', marginTop: 16 }}>
                                <div style={{ flexDirection: 'row', display: 'flex', backgroundColor: '#f5f5f5', height: 48, alignItems: 'center', width: 100, justifyContent: 'space-between', borderRadius: 24 }}>

                                    <Avatar src={getIcons(pool.token1, tokenIcons, true)} style={{ height: 32, width: 32, marginLeft: 12 }} />
                                    <Avatar src={getIcons(pool.token2, tokenIcons, true)} style={{ height: 32, width: 32, marginRight: 12 }} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 16 }}>
                                    <Typography style={{ fontSize: 18, color: '#363636', fontWeight: 'bold' }} >
                                        {pool.token1}-{pool.token2}
                                    </Typography>


                                    <Typography style={{ fontSize: 12, color: '#251CFF', marginTop: -4, fontWeight: 'bold' }}>
                                        {t('pool-addLiquidity')}
                                    </Typography>
                                </div>
                            </div>
                            <div style={{ height: 1, width: '100%', backgroundColor: '#8786A7', opacity: 0.2, marginTop: 16, marginBottom: 0 }} />

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, width: '100%' }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {pool.token1}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                    <Avatar alt="Coin Icon" src={getIcons(pool.token1, tokenIcons, true)} style={{ height: 20, width: 20, }} />

                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {roundingDown(pool.amount1, 4)} {pool.token1}
                                    </Typography>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '100%' }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {pool.token2}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                    <Avatar alt="Coin Icon" src={getIcons(pool.token2, tokenIcons, true)} style={{ height: 20, width: 20, }} />

                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {roundingDown(pool.amount2, 4)} {pool.token2}
                                    </Typography>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '100%' }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-minted')} {pool.token1}-{pool.token2}-LP

                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>


                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {roundingDown(pool.lpTokenAmount, 4)}
                                    </Typography>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '100%', marginBottom: 24 }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-time')}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>


                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {convertTimeString(pool.createdAt)} (UTC)
                                    </Typography>
                                </div>
                            </div>

                        </ListItem>
                        :
                        null
                }
                {
                    pool.type === 2 ?
                        <ListItem
                            button
                            onClick={() => {
                                // setLiquidityHistoryValue(pool)
                                // setLiquidityHistoryVisible(true)
                            }}

                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}

                        >

                            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', marginTop: 16 }}>
                                <div style={{ flexDirection: 'row', display: 'flex', backgroundColor: '#f5f5f5', height: 48, alignItems: 'center', width: 100, justifyContent: 'space-between', borderRadius: 24 }}>

                                    <Avatar src={getIcons(pool.token1, tokenIcons, true)} style={{ height: 32, width: 32, marginLeft: 12 }} />
                                    <Avatar src={getIcons(pool.token2, tokenIcons, true)} style={{ height: 32, width: 32, marginRight: 12 }} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 16 }}>
                                    <Typography style={{ fontSize: 18, color: '#363636', fontWeight: 'bold' }} >
                                        {pool.token1}-{pool.token2}
                                    </Typography>


                                    <Typography style={{ textTransform:'none',fontSize: 12, color: '#FF2D2D', marginTop: -4, fontWeight: 'bold', textTransform: 'uppercase' }}>
                                        {t('pool-removeLiquidity')}
                                    </Typography>
                                </div>
                            </div>
                            <div style={{ height: 1, width: '100%', backgroundColor: 'white', opacity: 0.2, marginTop: 16, marginBottom: 0 }} />

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, width: '100%' }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {pool.token1}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                    <Avatar alt="Coin Icon" src={getIcons(pool.token1, tokenIcons, true)} style={{ height: 20, width: 20, }} />

                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {roundingDown(pool.amount1, 4)} {pool.token1}
                                    </Typography>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '100%' }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {pool.token2}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>

                                    <Avatar alt="Coin Icon" src={getIcons(pool.token2, tokenIcons, true)} style={{ height: 20, width: 20, }} />

                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {roundingDown(pool.amount2, 4)} {pool.token2}
                                    </Typography>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '100%' }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-removeLiquidity-fee')}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {roundingDown(pool.fee1, 4)} {pool.token1} + {roundingDown(pool.fee2, 8)} {pool.token2}
                                    </Typography>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '100%' }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-destroyed')} {pool.token1}-{pool.token2}-LP
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {roundingDown(pool.lpTokenAmount, 4)}

                                    </Typography>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '100%', marginBottom: 24 }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-time')}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>


                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {convertTimeString(pool.createdAt)} (UTC)
                                    </Typography>
                                </div>
                            </div>

                        </ListItem>
                        :
                        null
                }
                {
                    pool.type === 3 ?
                        <ListItem
                            button
                            onClick={() => {
                                // setLiquidityHistoryValue(pool)
                                // setLiquidityHistoryVisible(true)
                            }}

                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}

                        >

                            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', marginTop: 16 }}>
                                <div style={{ flexDirection: 'row', display: 'flex', backgroundColor: 'white', height: 48, alignItems: 'center', width: 100, justifyContent: 'space-between', borderRadius: 24 }}>

                                    <Avatar src={getIcons(pool.token1, tokenIcons, true)} style={{ height: 32, width: 32, marginLeft: 12 }} />
                                    <Avatar src={getIcons(pool.token2, tokenIcons, true)} style={{ height: 32, width: 32, marginRight: 12 }} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 16 }}>
                                    <Typography style={{ fontSize: 18, color: '#363636', fontWeight: 'bold' }} >
                                        {pool.token1}-{pool.token2}
                                    </Typography>


                                    <Typography style={{ fontSize: 12, color: '#251CFF', marginTop: -4, fontWeight: 'bold' }}>
                                        {t('pool-poolRecord-lockLp')}
                                    </Typography>
                                </div>
                            </div>
                            <div style={{ height: 1, width: '100%', backgroundColor: 'white', opacity: 0.2, marginTop: 16, marginBottom: 0 }} />

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, width: '100%' }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-poolRecord-lock')} {pool.token1}-{pool.token2}-LP
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {roundingDown(pool.lpTokenAmount, 4)}

                                    </Typography>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '100%', marginBottom: 24 }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-time')}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>


                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {convertTimeString(pool.createdAt)} (UTC)
                                    </Typography>
                                </div>
                            </div>
                        </ListItem>
                        :
                        null
                }
                {
                    pool.type === 4 ?
                        <ListItem
                            button
                            onClick={() => {
                                // setLiquidityHistoryValue(pool)
                                // setLiquidityHistoryVisible(true)
                            }}

                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}

                        >

                            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', marginTop: 16 }}>
                                <div style={{ flexDirection: 'row', display: 'flex', backgroundColor: 'white', height: 48, alignItems: 'center', width: 100, justifyContent: 'space-between', borderRadius: 24 }}>

                                    <Avatar src={getIcons(pool.token1, tokenIcons, true)} style={{ height: 32, width: 32, marginLeft: 12 }} />
                                    <Avatar src={getIcons(pool.token2, tokenIcons, true)} style={{ height: 32, width: 32, marginRight: 12 }} />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 16 }}>
                                    <Typography style={{ fontSize: 18, color: '#363636', fontWeight: 'bold' }} >
                                        {pool.token1}-{pool.token2}
                                    </Typography>


                                    <Typography style={{ fontSize: 12, color: '#FF2525', marginTop: -4, fontWeight: 'bold' }}>
                                        {t('pool-poolRecord-unlockLp')}
                                    </Typography>
                                </div>
                            </div>
                            <div style={{ height: 1, width: '100%', backgroundColor: 'white', opacity: 0.2, marginTop: 16, marginBottom: 0 }} />

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, width: '100%' }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-poolRecord-unlock')} {pool.token1}-{pool.token2}-LP
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {roundingDown(pool.lpTokenAmount, 4)}

                                    </Typography>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '100%', marginBottom: 24 }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-time')}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>


                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {convertTimeString(pool.createdAt)} (UTC)
                                    </Typography>
                                </div>
                            </div>
                        </ListItem>
                        :
                        null
                }
                {
                    pool.type === 7 ?


                        <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'center', marginTop: 16, marginLeft: 16, marginRight: 16 }}>
                            <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', marginTop: 16, width: '100%' }}>
                                <div style={{ flexDirection: 'row', display: 'flex', backgroundColor: 'white', height: 48, alignItems: 'center', justifyContent: 'center', width: 48, borderRadius: 24 }}>

                                    <Avatar src={getIcons(pool.token, tokenIcons, true)} style={{ height: 32, width: 32 }} />
                                    {/* <Avatar src={coinImage(pool.token2)} style={{ height: 32, width: 32,marginRight:12 }} /> */}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 16 }}>

                                    <Typography style={{ fontSize: 16, color: '#363636', marginTop: -4, fontWeight: 'bold' }}>
                                        {t('pool-collectReward')} {pool.token}
                                    </Typography>
                                </div>
                            </div>
                            <div style={{ height: 1, width: '100%', backgroundColor: 'white', opacity: 0.2, marginTop: 16, marginBottom: 0 }} />

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16, width: '100%' }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-collectReward')}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                                    <Avatar alt="Coin Icon" src={getIcons(pool.token, tokenIcons, true)} style={{ height: 20, width: 20, }} />

                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {roundingDown(pool.amount, 4)} {pool.token}
                                    </Typography>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, width: '100%', marginBottom: 24 }}>
                                <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }}>
                                    {t('pool-time')}
                                </Typography>
                                <div style={{ display: 'flex', alignItems: 'center' }}>


                                    <Typography style={{ fontSize: 14, color: '#363636', fontWeight: 'bold' }} >
                                        {convertTimeString(pool.createdAt)} (UTC)
                                    </Typography>
                                </div>
                            </div>
                        </div>
                        : null
                }
            </div>
        )
    }
    const renderMyLockerCard = (pool) => {
        let poolInfo = liquidityPools.find(item => item.id === pool.pid)
        return (
            <div key={pool.id} style={{ backgroundColor: '#0C1A84', flexDirection: 'column', marginBottom: 40, display: 'flex', borderRadius: 16, width: '100%', overflow: 'hidden' }}>
                <div style={{ marginTop: 24, marginBottom: 24, marginLeft: 24, marginRight: 24, display: 'flex', flexDirection: 'column' }}>

                    <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center', justifyContent: 'space-between', }}>
                        <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
                            <div style={{ flexDirection: 'row', display: 'flex', backgroundColor: 'white', height: 48, alignItems: 'center', width: 100, justifyContent: 'space-between', borderRadius: 24 }}>

                                <Avatar src={getIcons(poolInfo ? poolInfo.token1 : null, tokenIcons, true)} style={{ height: 32, width: 32, marginLeft: 12 }} />
                                <Avatar src={getIcons(poolInfo ? poolInfo.token2 : null, tokenIcons, true)} style={{ height: 32, width: 32, marginRight: 12 }} />
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 16 }}>
                                <Typography style={{ fontSize: 18, color: 'white', fontWeight: 'bold' }} >
                                    {poolInfo ? poolInfo.token1 : null}-{poolInfo ? poolInfo.token2 : null}
                                </Typography>
                            </div>
                        </div>
                    </div>

                    <div style={{ height: 1, width: '100%', backgroundColor: 'white', opacity: 0.2, marginTop: 16, marginBottom: 16 }} />

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                        <Typography style={{ fontSize: 14, color: 'white', fontWeight: 'bold' }}>
                            {t('pool-myLocker-unlocked')} / {t('pool-myLocker-totalLocked')} LP
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography style={{ fontSize: 14, color: 'white', fontWeight: 'bold' }} >
                                {roundingDown(pool.unlockedAmount, 4)} / {roundingDown(pool.amount + pool.unlockedAmount, 4)}
                            </Typography>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 16 }}>
                        <Typography style={{ fontSize: 14, color: 'white', fontWeight: 'bold' }}>
                            {t('pool-myLocker-lockerTime')}
                        </Typography>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography style={{ fontSize: 14, color: 'white', fontWeight: 'bold' }} >
                                {convertTimeString(pool.createdAt) + "(UTC)"}
                            </Typography>
                        </div>
                    </div>

                </div>

                <div className={classes.wrapper}>
                    <Button
                        style={{ height: 52, width: '100%', backgroundColor: '#251CFF', textTransform: 'none', borderRadius: 0, opacity: !loggedIn || Date.parse(currentTime) < Date.parse(pool.releaseAt) || roundingDown(pool.amount, 4) <= 0 ? 0.5 : 1 }}
                        disabled={!loggedIn || Date.parse(currentTime) < Date.parse(pool.releaseAt) || roundingDown(pool.amount, 4) <= 0}
                        onClick={() => {
                            setUnlockVisible(true);
                            setUnlockValue({
                                pid: pool.pid,
                                id: pool.id
                            });
                        }}
                    >

                        <Typography style={{ fontSize: 16, fontWeight: 'bold', color: '#010846' }}>
                            {Date.parse(currentTime) < Date.parse(pool.releaseAt)
                                ? t('pool-myLocker-lockUntil') + " " + convertTimeString(pool.releaseAt) + "(UTC)"
                                : roundingDown(pool.amount, 4) <= 0
                                    ? t("pool-myLocker-unlocked")
                                    : t("pool-myLocker-unlock")
                            }
                        </Typography>
                    </Button>
                </div>

            </div>
        )
    }
    return (
        <div  style={{ backgroundColor: 'white', display: 'flex', minHeight: 900, flexDirection: 'column' }}>
            <Helmet>
                <title>SonicEx Layer 2 Pool</title>
                <meta name="description" content="Pool | SonicEx Layer 2, a fully decentralized trading protocol" />
            </Helmet>
            <div className='pool_cards__container'>


                <TabContext value={tabValue} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <TabList
                        centered
                        onChange={(event, newValue) => setTabValue(newValue)}
                        aria-label="simple tabs example"
                        style={{ backgroundColor: 'transparent', width: "110%", height: 60, alignItems: 'center', justifyContent: 'center' }}
                        TabIndicatorProps={{
                            style: {
                                background: '#271CFF', alignSelf: 'center', width: 80, height: 4, borderRadius: 0, display: "flex", justifyContent: 'center', marginLeft: width < 960 ? 0 : 40
                            },

                        }}

                    >
                        <Tab label={t("pool-pools")} value="liquidityPool" style={{textTransform:'none', fontSize: 12, fontWeight: 'bold', color: '#251CFF', height: '100%' }} />
                        <Tab label={t("pool-myPool")} value="myLiquidityPool" style={{ textTransform:'none',fontSize: 12, fontWeight: 'bold', color: '#251CFF' }} />
                        <Tab label={t("pool-locker")} value="myLocker" style={{ textTransform:'none',fontSize: 12, fontWeight: 'bold', color: '#251CFF' }} />
                        <Tab label={t("pool-poolRecord")} value="liquidityPoolHistory" style={{ textTransform:'none',fontSize: 12, fontWeight: 'bold', color: '#251CFF' }} />
                    </TabList>

                    <div style={{ height: 1, width: '100%', backgroundColor: '#8786A7', opacity: 0.2, marginTop: 12 }}></div>

                    {/*流动池*/}
                    <TabPanel value="liquidityPool" style={{ width: '89%' }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                {liquidityPools.map(pool => {
                                    return renderLiquidityPoolCard(pool)
                                })}
                            </Grid>
                        </Grid>
                    </TabPanel>
                    {/*我的流动池*/}
                    <TabPanel value="myLiquidityPool" style={{ width: '89%' }}>
                        {
                            !isValidBtcAddress(address) && !isValidDogeAddress(address) ?
                                <Button style={{ textTransform: 'none', backgroundColor: '#251CFF', fontSize: 16, fontWeight: 'bold', height: 42, borderRadius: 21, padding: 16, color: 'white', width: '100%' }} onClick={openWalletModal}>
                                    {button1}
                                </Button>
                                :
                                null
                        }
                        {
                            (isValidBtcAddress(address) || isValidDogeAddress(address)) && !loggedIn ?

                                <Button style={{ textTransform: 'none', width: "100%" }} className={button2Disabled ? classes.btn_disabled : classes.btn} onClick={(!registered || !loggedIn) && !loading ? () => unlockNew(
                                    address,
                                    chainId,
                                    network,
                                    registered,            
                                    currentWallet,
                                    dispatch,
                                    setAddress, setChainId, setNetwork, setWallet, setDappConnected, setPublicKey, setStartWatch, setAutoSign, setWalletDisconnected
                                ) : null} variant="outlined"  disabled={button2Disabled}>
                                    {button2}
                                </Button> : null
                        }
                        {
                            loggedIn ?
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        {myLiquidityPools.map(pool => {
                                            return renderMyLiquidityPoolCard(pool)
                                        })}
                                    </Grid>
                                </Grid> : null
                        }
                    </TabPanel>
                    {/*我的锁仓*/}
                    <TabPanel value="myLocker" style={{ width: '89%' }}>
                        {
                            !isValidBtcAddress(address) && !isValidDogeAddress(address) ?
                                <Button style={{ textTransform: 'none', backgroundColor: '#251CFF', fontSize: 16, fontWeight: 'bold', height: 42, borderRadius: 21, padding: 16, color: 'white', width: '100%' }} onClick={openWalletModal}>
                                    {button1}
                                </Button>
                                :
                                null
                        }
                        {
                            (isValidBtcAddress(address) || isValidDogeAddress(address)) && !loggedIn ?
                            <Button style={{ textTransform: 'none', width: '100%' }} className={button2Disabled ? classes.btn_disabled : classes.btn} onClick={(!registered || !loggedIn) && !loading ? () => unlockNew(
                                    address,
                                    chainId,
                                    network,
                                    registered,            
                                    currentWallet,
                                    dispatch,
                                    setAddress, setChainId, setNetwork, setWallet, setDappConnected, setPublicKey, setStartWatch, setAutoSign, setWalletDisconnected
                                ): null} variant="outlined" color="primary" disabled={button2Disabled}>
                                    {button2}
                                </Button> : null
                        }
                        {
                            loggedIn ?
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        {
                                            !loggedIn || unlockables.length <= 0 ?
                                                null
                                                :
                                                <div
                                                    style={{ flexDirection: 'row', height: 40, display: 'flex', alignItems: 'center', marginBottom: 16 }}

                                                >

                                                    {/* <Avatar variant="square" src={unlockIcon} style={{ height: 16, width: 16, marginRight: 4 }}></Avatar> */}

                                                    <Typography style={{ fontSize: 12, fontWeight: '600', color: '#8786A7' }}>
                                                        {t("pool-myLocker-unlockAll-1")}
                                                    </Typography>
                                                    <Button

                                                        onClick={async () => {
                                                            setUnlockAllVisible(true);
                                                            await unlockAllLp(address, chainId, network, Web3, dispatch, poolSigning, token, setSnackBarVisible, setSnackBarMessage, t)
                                                            setUnlockAllVisible(false)
                                                        }}
                                                        style={{ margin: i18n.language === 'en' ? 4 : 0, padding: 0, textTransform: 'none', display: 'inline-block', minHeight: 0, minWidth: 0 }}
                                                    >
                                                        <Typography style={{ fontSize: 12, fontWeight: '600', color: '#FF4646' }}>

                                                            {t("pool-myLocker-unlockAll")}
                                                        </Typography>

                                                    </Button>
                                                    <Typography style={{ fontSize: 12, fontWeight: '600', color: '#8786A7' }}>

                                                        {t("pool-myLocker-unlockAll-2")}

                                                    </Typography>
                                                </div>}
                                        {myLocker.map(pool => {
                                            return renderMyLockerCard(pool)
                                        })}
                                    </Grid>
                                </Grid> : null
                        }
                    </TabPanel>
                    {/*矿池记录*/}
                    <TabPanel value="liquidityPoolHistory" style={{ width: '89%' }}>
                        {
                            !isValidBtcAddress(address) && !isValidDogeAddress(address) ?
                                <Button style={{ textTransform: 'none', backgroundColor: '#251CFF', fontSize: 16, fontWeight: 'bold', height: 42, borderRadius: 21, padding: 16, color: 'white', width: '100%' }} onClick={openWalletModal}>
                                    {button1}
                                </Button>
                                :
                                null
                        }
                        {
                            (isValidBtcAddress(address) || isValidDogeAddress(address)) && !loggedIn ?

                                <Button style={{ textTransform: 'none', width: '100%' }} className={button2Disabled ? classes.btn_disabled : classes.btn} onClick={(!registered || !loggedIn) && !loading ? () => unlockNew(
                                    address,
                                    chainId,
                                    network,
                                    registered,            
                                    currentWallet,
                                    dispatch,
                                    setAddress, setChainId, setNetwork, setWallet, setDappConnected, setPublicKey, setStartWatch, setAutoSign, setWalletDisconnected
                                ) : null} variant="outlined" color="primary" disabled={button2Disabled}>
                                    {button2}
                                </Button> : null
                        }
                        {loggedIn ?
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    {/* <List className={classes.list}> */}
                                    {myLiquidityTransactions.map(pool => {
                                        return renderMyLiquidityTransactions(pool)
                                    })}
                                    {/* </List> */}
                                </Grid>
                            </Grid> : null
                        }
                        {/*记录详情*/}
                        {liquidityHistoryValue && Object.keys(liquidityHistoryValue).length ? (
                            <LiquidityHistoryDetail
                                onCancel={() => {
                                    setLiquidityHistoryVisible(false);
                                    setLiquidityHistoryValue({});
                                }}
                                modalVisible={liquidityHistoryVisible}
                                values={liquidityHistoryValue}
                            />
                        ) : null}
                    </TabPanel>
                </TabContext>

                {/*添加抵押*/}
                {addLiquidityValue && Object.keys(addLiquidityValue).length ? (
                    <AddLiquidity
                        onCancel={() => {
                            setAddLiquidityVisible(false);
                            setAddLiquidityValue({});
                        }}
                        modalVisible={addLiquidityVisible}
                        values={addLiquidityValue}
                        address={address}
                        chainId={chainId}
                        network={network}
                        currentWallet={currentWallet}
                        web3={Web3}
                        t
                    />
                ) : null}

                {/*解除抵押*/}
                {removeLiquidityValue && Object.keys(removeLiquidityValue).length ? (
                    <RemoveLiquidity
                        onCancel={() => {
                            setRemoveLiquidityVisible(false);
                            setRemoveLiquidityValue({});
                        }}
                        modalVisible={removeLiquidityVisible}
                        values={removeLiquidityValue}
                        address={address}
                        chainId={chainId}
                        network={network}
                        web3={Web3}
                        t
                        currentWallet={currentWallet}
                    />
                ) : null}

                {/*LP锁仓*/}
                {lockValue && Object.keys(lockValue).length ? (
                    <Lock
                        onCancel={() => {
                            setLockVisible(false);
                            setLockValue({});
                        }}
                        modalVisible={lockVisible}
                        values={lockValue}
                        address={address}
                        chainId={chainId}
                        network={network}
                        web3={Web3}
                        t
                    />
                )
                    :
                    null
                }

                {/*LP解锁*/}
                {unlockValue && Object.keys(unlockValue).length ? (
                    <Unlock
                        onCancel={() => {
                            setUnlockVisible(false);
                            setUnlockValue({});
                        }}
                        modalVisible={unlockVisible}
                        values={unlockValue}
                        address={address}
                        chainId={chainId}
                        network={network}
                        web3={Web3}
                        t
                    />
                )
                    :
                    null
                }

                {/*解锁全部*/}
                {unlockAllVisible ? (
                    <UnlockAll
                        onCancel={() => {
                            setUnlockAllVisible(false);
                        }}
                        modalVisible={unlockAllVisible}
                        address={address}
                        chainId={chainId}
                        network={network}
                        web3={Web3}
                        t
                    />)
                    :
                    null
                }

                {/*收取奖励确认*/}
                {harvestLiquidityValue && Object.keys(harvestLiquidityValue).length ? (
                    <HarvestLiquidity
                        onCancel={() => {
                            setHarvestLiquidityVisible(false);
                            setHarvestLiquidityValue({});
                        }}
                        modalVisible={harvestLiquidityVisible}
                        values={harvestLiquidityValue}
                        t
                    />
                )
                    :
                    null
                }

                {/*取消签名提示框*/}
                <Snackbar
                    open={snackBarVisible}
                    onClose={handleSnackClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    autoHideDuration={5000}
                    message={snackBarMessage}
                    key={"resultPopUp"}
                    action={
                        <React.Fragment>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={handleSnackClose}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </React.Fragment>
                    }
                />
            </div>

            <div style={{ marginBottom: 200, marginTop: 24, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <div style={{ maxWidth: 600, flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>

                    <div style={{ maxWidth: 600, flexDirection: 'row', display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                        <Avatar src={rewardIcon} style={{ height: 24, width: 24 }} />
                        <Typography style={{ fontSize: 16, color: '#8786A7', fontWeight: 'bold' }}>
                            {t('pool-footerAnnounceTitle')}
                        </Typography>

                    </div >
                    <Typography style={{ fontSize: 12, color: '#8786A7', fontWeight: 'bold', marginTop: 4 }}>
                        {t('pool-footerAnnounceContent')}
                    </Typography>
                </div>

            </div>
        </div>
    )
}

export default withTranslation()(Pool);
